import {CustomEventsConfig} from "../../forms/custom-events-form/custom-events-form.component";

export function isCustomEventsConfig(config: unknown): config is CustomEventsConfig {
    return (
        config !== null &&
        typeof config === 'object' &&
        'columns' in config &&
        'event_types' in config
    );
}
